import { Component, OnInit, Input, EventEmitter, Optional, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LoginService } from '../../services/login/login.service';
import { movieVM } from '../../models/movieVM';
import { SelectItem } from 'primeng/components/common/api';
import { Message } from 'primeng/components/common/api';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  constructor(private _loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router
  ) {

  }
  isLoading: boolean = false;
  msgs: Message[] = [];
  model: any = {};
  user: any = {};

  ngOnInit() {
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.router.navigate(['/dashboard/movies'])
    }
  }

  onSubmit(f: any) {
    this.isLoading = true;
    this._loginService.userLogin(this.model).subscribe(data => {
      debugger;
      this.isLoading = false;
      this.user = data;
      localStorage.setItem("currentUser", this.user.userToken)
      this.router.navigate(['/dashboard/movies'])
    }, error => {
      debugger;
      this.isLoading = false;
      this.msgs.push({ severity: 'error', summary: 'Error', detail: error })
      this.hideMessage();
    });
  }

  hideMessage() {
    setTimeout(() => {
      this.msgs = [];
    }, 3000);
  }

}





// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts